<template>
  <div>
    <div class="op">
  
      <Candode v-on:childByValue="childByValue" :address="address" v-on:getTownlength="getTownlength"></Candode>
  
  <!--<div class="add" style="margin-left:0">
     <el-select clearable size="mini" @change="handleChange" v-model="town" placeholder="请选择乡/镇">
      <el-option
        v-for="item in list"
        :key="item.town_id"
        :label="item.town_name"
        :value="item.town_id+','+item.town_name">
      </el-option>
    </el-select>
    </div>
    <div class="add">
    <el-select size="mini" clearable @change="torz" v-model="village" placeholder="请选择村">
      <el-option
        v-for="item2 in list2"
        :key="item2.village_id"
        :label="item2.village_name"
        :value="item2.village_id+','+item2.village_name">
      </el-option>
    </el-select>
  </div>-->
  <div class="nam">
    <el-input v-model="name" style="margin-left:10px" clearable size="mini" placeholder="请输入姓名"></el-input>
  </div>
    <div class="idc">
    <el-input v-model="idcard" @change="toup" size="mini" clearable placeholder="请输入身份证号"></el-input>
  </div>
  
  <div class="add">
      <el-date-picker
        v-model="time"
        size='mini'
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
  
  </div>
  
  </div>
  <div class="op" style="margin-top:10px">
     <div class="add"  style="margin-left:0">
    <el-select v-model="ywtype" placeholder="请选择业务类型" size="mini">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
  </div>
  <el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">搜索</el-button>
  </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      stripe>
        <el-table-column
        label="身份证号"
        width="180">
        <template slot-scope="scope">
        <span style="color:#27ADF8;cursor:pointer;border-bottom:1px solid #27ADF8" @click="toOwm(scope.row.identityNumber)"> {{ scope.row.identityNumber }}</span>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="personName"
        label="姓名"
        width="100">
      </el-table-column>
        <el-table-column
        prop="verify_types"
         width="180"
        label="补贴类型">
      </el-table-column>
       <el-table-column
        prop="nowAddress"
        label="认证地点">
      </el-table-column>
       <el-table-column
        prop="createTime"
        label="认证时间">
      </el-table-column>
  <el-table-column
  
       label="操作">
        <template slot-scope="scope">
          <el-button
          type="primary"
            size="mini"
            icon="el-icon-s-check"
            @click="handle(scope.$index, scope.row)">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pone"
        :page-size='10'
        layout="total, prev, pager, next, jumper"
        :total="totals"
        :current-page.sync="Page"
        @current-change="current_change"
  >
      </el-pagination>
    </div>
  </template>
  
  <style>
  .op {
    display: flex;
    align-items: center;
  }
  .idc {
    width: 200px;
  }
  .nam {
    margin-right: 20px;
  }
  .ywtyoe {
    width: 200px;
    margin-left: 20px;
  }
  .el-table .warning-row {
    background: oldlace;
  }
  
  .el-table .success-row {
    background: #f0f9eb;
  }
  .pone {
    margin-top: 40px;
  }
  .el-timeline {
    padding-left: 20px;
  }
  .add {
    margin-left: 20px;
  }
  </style>
  
  <script>
  import trimupcase from "../../utils/trimupcase";
  import Axios from "axios";
  import Cookies from "js-cookie";
  import CryptoJS from "crypto-js";
  import { Loading } from "element-ui";
  import { listtown } from "../../utils/address";
  import { baseUrl2 } from "../../utils/global";
  import defaultImg from "../../assets/defaultPicture.jpg";
  import Candode from "../Core/candode";
  import { decryptByDES, decrypt } from "../../utils/cypto";
  import { formatDate } from "../../utils/datetime";
  import { getType } from "../../utils/typeAuth";
  export default {
    components: {
      Candode
    },
    data() {
      return {
        list: [],
        name: "",
        town: "",
        village: "",
        defaultImg: defaultImg,
        townList: [],
        imgUrl: "http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/",
        Page: 1,
        totals: 0,
        idcard: "",
        info: "",
        ywtype: "",
        tableData: [],
        list2: [],
        //认证状态
        state: "",
        stateList: [
          {
            value: "0",
            label: "认证成功"
          },
          {
            value: "2",
            label: "认证失败"
          },
          {
            value: "3",
            label: "未认证"
          }
        ],
        //时间
        time: "",
        //年龄
        age: "",
        ageList: [
          {
            value: "",
            label: "所有年龄段"
          },
          {
            value: "1",
            label: "55岁以下"
          },
          {
            value: "2",
            label: "55岁-59岁"
          },
          {
            value: "3",
            label: "60岁以上"
          },
          {
            value: "4",
            label: "60岁-90岁"
          },
          {
            value: "5",
            label: "90岁以上"
          },
          {
            value: "6",
            label: "100岁以上"
          }
        ],
        //年龄计算方式
        agemeth: "1",
        agemethList: [
          {
            value: "1",
            label: "按年计算"
          },
          {
            value: "2",
            label: "按月计算"
          }
        ],
        //参保类型
        ywtype: "",
        address: [],
        options1: [],
        townlen: 1,
        flag: true
      };
    },
    methods: {
      toOwm(s) {
        this.$router.push({
          name: "个人信息",
          params: {
            idcard: s
          }
        });
      },
      toup() {
        this.idcard = this.idcard.toUpperCase();
      },
      //审核
      handle(s, d) {
        console.log(d);
        this.$router.push({
          name: "人工审核",
          params: d
        });
      },
      strReplace(msg) {
        let str = getType(msg);
        return str;
      },
      formatDate: formatDate,
      childByValue(val, nm, flag) {
        if (flag) {
          if (this.townList.length == 0) {
            this.townList = val;
          } else {
            this.address = this.townList.slice(nm, this.townList.length);
          }
        } else {
          this.townList = val;
          //this.address=this.townList.slice(nm-1,this.townList.length-1)
        }
        this.serchTest();
      },
      getTownlength(val) {
        this.townlen = val;
      },
      //搜索
      serch() {
        // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";
  
        // if (!isTown) {
        //   this.$message({
        //     type: "warning",
        //     message: "请选择县/区及以下区域进行操作"
        //   });
        //   return;
        // }
        this.serchTest(1);
      },
      serchCode() {
        let data = {
          pageNum: this.Page,
          pageSize: 10,
          personName: this.name ? this.Encrypt(this.name) : "",
          province_name: this.townList[0] ? this.townList[0].split(",")[0] : "",
          city_name: this.townList[1] ? this.townList[1].split(",")[0] : "",
          county_name: this.townList[2] ? this.townList[2].split(",")[0] : "",
          town_name: this.townList[3] ? this.townList[3].split(",")[0] : "",
          village_name: this.townList[4] ? this.townList[4].split(",")[0] : "",
          group_name: this.townList[5] ? this.townList[5].split(",")[0] : "",
          birthday: this.age,
          identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
          verify_type: this.ywtype,
          personName: this.name ? this.Encrypt(this.name) : "",
          provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
          cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
          countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
          townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
          villageName: this.townList[4] ? this.townList[4].split(",")[1] : "",
          groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
          start_time: this.time ? this.formatDate(this.time[0]) : "",
          end_time: this.time ? this.formatDate(this.time[1]) : "",
          quarry_rule: this.agemeth
        };
  
        this.$api.getlist
          .perVerifyList(data)
          .then(res => {
            let result = res.data.list;
            this.totals = res.data.total;
  
            if (result.length == 0) {
              this.Page = this.Page - 1;
              if (this.flag) {
                this.serchCode();
              }
              this.flag = false;
              return;
            }
  
            for (var i in result) {
              result[i].identityNumber = this.decrypt(result[i].identityNumber);
              result[i].personName = this.decrypt(result[i].personName);
              result[i].telphone = result[i].telphone
                ? this.decrypt(result[i].telphone)
                : "";
              result[i].createTimes = result[i].createTime;
              result[i].createTime = this.formatDate(result[i].createTime);
              result[i].verify_types = this.strReplace(result[i].verify_types);
              result[i].match_state =
                result[i].match_state == 0
                  ? "认证成功"
                  : result[i].match_state == 2
                    ? "认证失败"
                    : result[i].match_state == 3
                      ? "审核中"
                      : "";
            }
            this.tableData = result;
            sessionStorage.setItem("datas", JSON.stringify(this.$data));
          })
          .catch(res => {});
      },
      serchTest(s) {
        // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";
  
        // if (!isTown) {
        //   this.$message({
        //     type: "warning",
        //     message: "请选择县/区及以下区域进行操作"
        //   });
        //   return;
        // }
        Loading.service();
        this.idcard = trimupcase(this.idcard);
        var data = {
          pageNum: this.Page,
          pageSize: 10,
          personName: this.name ? this.Encrypt(this.name) : "",
          province_name: this.townList[0] ? this.townList[0].split(",")[0] : "",
          city_name: this.townList[1] ? this.townList[1].split(",")[0] : "",
          county_name: this.townList[2] ? this.townList[2].split(",")[0] : "",
          town_name: this.townList[3] ? this.townList[3].split(",")[0] : "",
          village_name: this.townList[4] ? this.townList[4].split(",")[0] : "",
          group_name: this.townList[5] ? this.townList[5].split(",")[0] : "",
          personName: this.name ? this.Encrypt(this.name) : "",
          provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
          cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
          countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
          townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
          villageName: this.townList[4] ? this.townList[4].split(",")[1] : "",
          groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
          birthday: this.age,
          identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
          match_state: this.state,
          verify_type: this.ywtype,
          start_time: this.time ? this.formatDate(this.time[0]) : "",
          end_time: this.time ? this.formatDate(this.time[1]) : "",
          quarry_rule: this.agemeth
        };
        this.$api.getlist
          .perVerifyList(data)
          .then(res => {
            let result = res.data.list;
            this.totals = res.data.total;
            for (var i in result) {
              result[i].identityNumber = this.decrypt(result[i].identityNumber);
              result[i].personName = this.decrypt(result[i].personName);
              result[i].telphone = result[i].telphone
                ? this.decrypt(result[i].telphone)
                : "";
              result[i].createTimes = result[i].createTime;
              result[i].createTime = this.formatDate(result[i].createTime);
              result[i].verify_types = this.strReplace(result[i].verify_types);
              result[i].match_state =
                result[i].match_state == 0
                  ? "认证成功"
                  : result[i].match_state == 2
                    ? "认证失败"
                    : result[i].match_state == 3
                      ? "审核中"
                      : "";
            }
            this.tableData = result;
            sessionStorage.setItem("datas", JSON.stringify(this.$data));
  
            let loadingInstance = Loading.service();
            this.$nextTick(() => {
              //以服务的方式调用的 Loading需要异步关闭
              loadingInstance.close();
            });
          })
          .catch(err => {
            let loadingInstance = Loading.service();
            this.$nextTick(() => {
              //以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
          });
      },
      current_change(ss) {
        this.serchTest(ss);
      },
      handleChange() {},
      torz() {},
      handleDelete(g, h) {
        console.log(g);
        console.log(h);
      },
      Encrypt(word) {
        //aes加密
        var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
        let srcs = CryptoJS.enc.Utf8.parse(word);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
      },
      decrypt(word) {
        var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
        var decrypt = CryptoJS.AES.decrypt(word, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
      },
      decryptDes(message) {
        var keyHex = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
        var decrypted = CryptoJS.DES.decrypt(
          {
            ciphertext: CryptoJS.enc.Hex.parse(message)
          },
          keyHex,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8);
      }
    },
  
    created() {
      if (sessionStorage.getItem("datas")) {
        Object.assign(this.$data, JSON.parse(sessionStorage.getItem("datas")));
        this.ywtype = "";
        this.options1 = [];
        this.multipleSelection = [];
        this.flag = true;
      }
      let Obj = {
        ywtype: ""
      };
  
      let arr;
      if (sessionStorage.getItem("typeControll") == "null") {
        arr = JSON.parse(sessionStorage.getItem("codes"));
      } else {
        arr = JSON.parse(sessionStorage.getItem("typeControll"));
      }
  
      for (let i in arr) {
        this.options1.push({
          label: getType(arr[i]),
          value: arr[i]
        });
      }
      this.ywtype = Obj.ywtype ? getType(Obj.ywtype) : arr[0];
    }
  };
  </script>
  


// WEBPACK FOOTER //
// src/views/Myvue/authVerify.vue